import React from "react";

import styles from "./Divider.module.css";

const Divider: React.FC = () => {
  return <div className={styles.dividerDiv} />;
};

export default Divider;
